const COUNT_KEY = "support_unread_count";
const EVENT_NAME = "support-notifications-updated";

export const getSupportUnreadCount = () => {
  const value = Number(localStorage.getItem(COUNT_KEY) || 0);
  return Number.isFinite(value) && value > 0 ? value : 0;
};

export const notifySupportRequestCreated = (payload = {}) => {
  const count = getSupportUnreadCount() + 1;
  localStorage.setItem(COUNT_KEY, String(count));
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, {
      detail: {
        count,
        notification: {
          id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
          title: payload.title || "New support request",
          description: payload.description || "A new support request was created",
        },
      },
    })
  );
};

export const clearSupportUnreadCount = () => {
  localStorage.setItem(COUNT_KEY, "0");
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, {
      detail: { count: 0 },
    })
  );
};

export const SUPPORT_NOTIFICATION_EVENT = EVENT_NAME;
